module.exports = __webpack_public_path__ + "static/media/skoda.33b0d1b2.png";